import React, { useContext } from 'react';
import ReactMarkdown from 'react-markdown';

import AppContext from '../../context/AppContext';


const Celebi = () => {
    const context = useContext(AppContext);
    const { state } = context;
    const { data, theme } = state;



    const Photo = () =>
        data.profile.photo !== '' && (
            <div className="flex justify-center mb-6">
                <img
                    className="w-32 h-32 rounded-full object-cover border-4 border-white"
                    src={data.profile.photo}
                    alt="Resume Photograph"
                />
            </div>
        );

    const ContactItem = ({ icon, value, link = '#' }) =>
        value && (
            <div className="flex items-center my-3 text-sm">
                <span className="material-icons text-lg mr-2" style={{ color: theme.colors.background }}>
                    {icon}
                </span>
                <a href={link} className="text-white hover:opacity-75">
                    <span className="font-medium break-all">{value}</span>
                </a>
            </div>
        );

    const SidebarHeading = ({ title }) => (
        <h6 className="text-xs font-bold uppercase mt-8 mb-4 text-white tracking-wider border-b border-white opacity-75 pb-1">
            {title}
        </h6>
    );

    const SkillItem = x => (
        <span
            key={x}
            className="text-xs rounded px-2 py-1 font-medium my-1 mr-1 inline-block text-white"
            style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)' }}
        >
            {x}
        </span>
    );

    const Skills = () =>
        data.skills &&
        data.skills.enable && (
            <div>
                <SidebarHeading title={data.skills.heading} />
                <div className="flex flex-wrap">{data.skills.items.map(SkillItem)}</div>
            </div>
        );

    const LanguageItem = x => (
        <div key={x.id} className="flex flex-col mb-2 text-white">
            <div className="flex justify-between items-center">
                <h6 className="text-sm font-medium">{x.key}</h6>
            </div>
            <div className="h-2 w-full rounded mt-1" style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)' }}>
                <div
                    className="h-full bg-white rounded"
                    style={{ width: `${(x.value / 5) * 100}%` }}
                />
            </div>
        </div>
    );

    const Languages = () =>
        data.languages &&
        data.languages.enable && (
            <div>
                <SidebarHeading title={data.languages.heading} />
                <div>{data.languages.items.filter(x => x.enable).map(LanguageItem)}</div>
            </div>
        );

    const SidebarAwardItem = x => (
        <div key={x.title} className="mb-3 text-white">
            <h6 className="font-semibold text-sm">{x.title}</h6>
            <p className="text-xs opacity-75">{x.subtitle}</p>
        </div>
    );

    const Awards = () =>
        data.awards &&
        data.awards.enable && (
            <div>
                <SidebarHeading title={data.awards.heading} />
                {data.awards.items.filter(x => x.enable).map(SidebarAwardItem)}
            </div>
        );

    const SidebarCertificationItem = x => (
        <div key={x.title} className="mb-3 text-white">
            <h6 className="font-semibold text-sm">{x.title}</h6>
            <p className="text-xs opacity-75">{x.subtitle}</p>
        </div>
    );

    const Certifications = () =>
        data.certifications &&
        data.certifications.enable && (
            <div>
                <SidebarHeading title={data.certifications.heading} />
                {data.certifications.items.filter(x => x.enable).map(SidebarCertificationItem)}
            </div>
        );

    const MainHeading = ({ title }) => (
        <h6
            className="text-sm font-bold uppercase mt-6 mb-4 pb-1 border-b-2 tracking-wider"
            style={{ color: theme.colors.primary, borderColor: theme.colors.primary }}
        >
            {title}
        </h6>
    );

    const Header = () => (
        <div className="mt-8 mb-8">
            <h1 className="text-4xl font-bold uppercase leading-none" style={{ color: theme.colors.primary }}>
                {data.profile.firstName} {data.profile.lastName}
            </h1>
            <h2 className="text-xl font-medium tracking-wide mt-2" style={{ color: theme.colors.accent }}>
                {data.profile.subtitle}
            </h2>
        </div>
    );

    const Objective = () =>
        data.objective &&
        data.objective.enable && (
            <div className="mb-6">
                <MainHeading title={data.objective.heading} />
                <ReactMarkdown className="text-sm text-gray-800 leading-relaxed" source={data.objective.body} />
            </div>
        );

    const WorkItem = x => (
        <div key={x.title} className="mb-6">
            <div className="flex justify-between items-baseline">
                <h6 className="font-bold text-base" style={{ color: theme.colors.primary }}>{x.title}</h6>
                <span className="text-xs font-medium text-gray-600">
                    {x.start} - {x.end}
                </span>
            </div>
            <p className="text-sm font-medium mb-2" style={{ color: theme.colors.accent }}>{x.role}</p>
            <ReactMarkdown className="text-sm text-gray-800 leading-relaxed" source={x.description} />
        </div>
    );

    const Work = () =>
        data.work &&
        data.work.enable && (
            <div>
                <MainHeading title={data.work.heading} />
                {data.work.items.filter(x => x.enable).map(WorkItem)}
            </div>
        );

    const EducationItem = x => (
        <div key={x.name} className="mb-4">
            <div className="flex justify-between items-baseline">
                <h6 className="font-bold text-base" style={{ color: theme.colors.primary }}>{x.name}</h6>
                <span className="text-xs font-medium text-gray-600">
                    {x.start} - {x.end}
                </span>
            </div>
            <div className="flex justify-between items-center">
                <p className="text-sm font-medium" style={{ color: theme.colors.accent }}>{x.major}</p>
                <span className="text-sm font-bold text-gray-700">{x.grade}</span>
            </div>

            <ReactMarkdown className="mt-1 text-sm text-gray-800" source={x.description} />
        </div>
    );

    const Education = () =>
        data.education &&
        data.education.enable && (
            <div>
                <MainHeading title={data.education.heading} />
                {data.education.items.filter(x => x.enable).map(EducationItem)}
            </div>
        );

    const ReferenceItem = x => (
        <div key={x.id} className="flex flex-col mb-4">
            <h6 className="text-sm font-bold" style={{ color: theme.colors.primary }}>{x.name}</h6>
            <span className="text-xs italic text-gray-600">{x.position}</span>
            <span className="text-xs text-gray-600">{x.phone}</span>
            <span className="text-xs text-gray-600">{x.email}</span>
            <ReactMarkdown className="mt-1 text-sm text-gray-800" source={x.description} />
        </div>
    );

    const References = () =>
        data.references &&
        data.references.enable && (
            <div>
                <MainHeading title={data.references.heading} />
                <div className="grid grid-cols-2 gap-4">
                    {data.references.items.filter(x => x.enable).map(ReferenceItem)}
                </div>
            </div>
        );

    const ExtraItem = x => (
        <div key={x.key} className="flex justify-between text-sm py-1 border-b border-gray-200">
            <span className="font-medium text-gray-700">{x.key}</span>
            <span className="text-gray-900">{x.value}</span>
        </div>
    );

    const Extras = () =>
        data.extras &&
        data.extras.enable && (
            <div className="mt-6">
                <MainHeading title={data.extras.heading} />
                <div className="flex flex-col">
                    {data.extras.items.filter(x => x.enable).map(ExtraItem)}
                </div>
            </div>
        );

    return (
        <div
            style={{
                fontFamily: theme.font.family,
                backgroundColor: theme.colors.background,
            }}
        >
            <div className="grid grid-cols-12 min-h-screen">
                {/* Left Sidebar */}
                <div
                    className="col-span-4 p-8 text-white"
                    style={{ backgroundColor: theme.colors.primary }}
                >
                    <Photo />

                    <div className="mb-6">
                        <ContactItem icon="phone" value={data.profile.phone} link={`tel:${data.profile.phone}`} />
                        <ContactItem
                            icon="language"
                            value={data.profile.website}
                            link={`http://${data.profile.website}`}
                        />
                        <ContactItem
                            icon="alternate_email"
                            value={data.profile.email}
                            link={`mailto:${data.profile.email}`}
                        />
                        <ContactItem icon="location_on" value={data.profile.address.line3} />
                    </div>

                    <Skills />
                    <Languages />
                    <Awards />
                    <Certifications />
                </div>

                {/* Right Main Content */}
                <div className="col-span-8 p-8 bg-white">
                    <Header />
                    <Objective />
                    <Work />
                    <Education />
                    <References />
                    <Extras />
                </div>
            </div>
        </div>
    );
};

export default Celebi;
